import { Job, JobType } from '../../Job/Job.type';
import { Employee } from '../../Employee/Employee.type';
import { Source } from '../../Source/Source.type';
import { EventStatus } from '../../Event/Status/EventStatus.type';
import { Region } from '../../Region/Region.type';
import { Department } from '../../Department/Department.type';
import { PersonHistory } from './History/History.type';
import { AttachEditState, Attachment } from '../../Attachment/Attachment.type';
import { Tag } from '../../ControlPanel/TagControl/TagControl.type';

export enum PersonRecordType {
  RECORD = 'RECORD',
  LABEL = 'LABEL',
}

export interface PersonRecordPreInfo {
  id: number;
  personId: number;
}

export interface PersonRecord extends PersonRecordPreInfo {
  originalId?: number;
  tmpPerson?: any;
  date?: number;
  type: string;
  salary?: string | null;
  salaryBrutto?: string | null;
  comment?: string;
  source?: Source;
  status?: EventStatus;
  jobs?: Job[];
  jobType?: JobType;
  author?: Employee;
  hr?: Employee;
  recruiter?: Employee;
  techSpecialist?: Employee;
  techSpecialists?: Employee[];
  referral?: Employee;
  region?: Region;
  department?: Department;
  createdAt: number;
  updatedAt: number;
  attachments?: Attachment[];
  tags: Tag[];
  history?: PersonHistory[];
  notifications_counter: number;
  history_counter: number;
}

export interface PersonRecordFetch {
  personId: number | string;
  page?: number;
  perPage?: number;
}

export interface PersonRecordHistoryFetch {
  personId: number | string;
  recordId: number;
  page?: number;
  perPage?: number;
}

export interface PersonRecordCreateFetch extends PersonRecordFetch {
  statusId?: number | string;
  date?: number;
  jobsId?: Array<string | number>;
  jobTypeId?: number | string;
  sourceId?: number | string;
  hrId?: number | string;
  techSpecialistId?: number | string;
  referralId?: number | string;
  regionId?: number | string;
  departmentId?: number | string;
  recruiterId?: number | string;
  salary?: string | null;
  salaryBrutto?: string | null;
  comment?: string;
  attachments?: AttachEditState[];
  tags?: Tag[];
}

export interface PersonRecordUpdateFetch extends PersonRecordCreateFetch {
  recordId: number | string;
}
